/**
 * TRUS-725: report types that are ONE health plan's file. Offered only for programs whose
 * health plan (chosen once in program setup) is that plan, so an org that bills Health Net
 * never sees the SFHP invoice. Mirrors PLAN_SPECIFIC_REPORT_TYPES on the server.
 *
 * A program with no plan chosen yet keeps the pre-TRUS-725 behaviour, as on the server
 * (_plan_specific_types_hidden / _reject_wrong_plan): it can still take a plan-specific
 * report, and an org with no plan chosen on any program is offered every type. Only a
 * program whose chosen plan is a DIFFERENT plan is excluded.
 */
export interface PlanProgramOption {
  id: number;
  name: string;
  /** payers.payer_id of the program's health plan, e.g. 'SFHP'. */
  payer_key?: string | null;
}

export const PLAN_SPECIFIC_TYPES: Record<string, string> = { sfhp_invoice: 'SFHP' };

const planKey = (pr: PlanProgramOption): string => (pr.payer_key || '').trim().toUpperCase();

export const programsForReportType = <T extends PlanProgramOption>(type: string, programs: T[]): T[] => {
  const plan = PLAN_SPECIFIC_TYPES[type];
  if (!plan) return programs;
  return programs.filter((pr) => !planKey(pr) || planKey(pr) === plan);
};

export const offeredReportTypes = (types: string[], programs: PlanProgramOption[]): string[] => {
  const chosen = new Set(programs.map(planKey).filter(Boolean));
  if (chosen.size === 0) return types;
  return types.filter((t) => !PLAN_SPECIFIC_TYPES[t] || chosen.has(PLAN_SPECIFIC_TYPES[t]));
};
